import type { ErrorComponentProps } from "@tanstack/react-router";
import { LoaderCircle } from "lucide-react";
import { Button } from "@/shared/components/ui/button";

// Rendered by defaultErrorComponent so uncaught route errors show a message, not a white screen.
export function RouteErrorFallback({ error, reset }: ErrorComponentProps) {
  const message = error instanceof Error ? error.message : "Något gick fel.";
  return (
    <div className="mx-auto max-w-sm space-y-4 pt-16 text-center">
      <h2 className="text-xl font-semibold">Något gick fel</h2>
      <p className="text-sm text-muted-foreground">{message}</p>
      <Button variant="outline" size="sm" onClick={reset}>
        Försök igen
      </Button>
    </div>
  );
}

// Router pending fallback while loaders/guards resolve, so transitions don't flash.
export function RoutePendingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <LoaderCircle className="size-8 animate-spin text-muted-foreground" />
    </div>
  );
}
